module.exports = "/static/assets/fb5cf9e240a84ac8aa1e41a56e48701d.png";